import { FC, useCallback, useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import ROUTES from 'shared/constants/routes';
import { Icons } from '../ui/Icons';
import { Button } from '../ui/Button';
import { useAppDispatch } from 'shared/helpers/useAppDispatch/useAppDispatch';
import { webLoginActions } from 'pages/webLogin/store/store';
import { useSelector } from 'react-redux';
import { getFormType } from 'pages/webLogin/store/selectors/loginSelectors';
import './index.scss';

// type TLocalHeaderData = {
//   name: string;
//   url: string;
// };

// const localHeaderData: TLocalHeaderData[] = [
//   {
//     name: ROUTES.TESTS.NAME,
//     url: ROUTES.MAIN.ROUTE,
//   },
//   {
//     name: ROUTES.TASKS.NAME,
//     url: ROUTES.MAIN.ROUTE,
//   },
//   {
//     name: ROUTES.GAMES.NAME,
//     url: ROUTES.TASKS.ROUTE,
//   },
// ];

export const Header: FC = () => {
  const dispatch = useAppDispatch();
  const dropdownRef = useRef<HTMLDivElement | null>(null);
  const [openMenu, setOpenMenu] = useState<boolean>(false);
  const formType = useSelector(getFormType);
  const isActiveLoginButton = formType === 'login' ? 'active' : '';
  const isActiveRegButton = formType === 'registration' ? 'active' : '';

  const handleOpenMenu = useCallback(() => {
    setOpenMenu(true);
  }, []);

  const handleCloseMenu = useCallback(() => {
    setOpenMenu(false);
  }, []);

  useEffect(() => {
    if (!openMenu) return;

    const handlePointerDown = (event: PointerEvent) => {
      const target = event.target as Node | null;
      if (
        dropdownRef.current &&
        target &&
        !dropdownRef.current.contains(target)
      ) {
        handleCloseMenu();
      }
    };

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        handleCloseMenu();
      }
    };

    document.addEventListener('pointerdown', handlePointerDown, true);
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('pointerdown', handlePointerDown, true);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [openMenu, handleCloseMenu]);

  const setWebLoginForm = useCallback(() => {
    dispatch(webLoginActions.setFormType('login'));
  }, [dispatch]);

  const setWebRegistrationForm = useCallback(() => {
    dispatch(webLoginActions.setFormType('registration'));
  }, [dispatch]);

  return (
    <header className="header">
      <div className="header__inner">
        <div className="header-logo">
          <Link className="header-logo__link" to={ROUTES.MAIN.ROUTE}>
            <img src="/logo.svg" alt="" width="230" height="37" />
            <span>Designed for decisions</span>
          </Link>
        </div>

        <nav className="header-mainnav" ref={dropdownRef}>
          <Button
            className="header-mainnav__button"
            variant="link"
            onClick={handleOpenMenu}
          >
            <Icons name="icon_burger" />
          </Button>
          <ul
            className={`header-mainnav__list 
              ${openMenu ? 'header-mainnav__list--opened' : ''}`}
          >
            {/* {localHeaderData.map(data => (
              <Link
                className="header-mainnav__link"
                to={data.url}
                key={data.name}
              >
                {data.name}
              </Link>
            ))} */}
            <li className="header-mainnav__item header-mainnav__item--mobile header-mainnav__item--login">
              <Button
                className={`header-auth__login ${isActiveLoginButton}`}
                onClick={setWebLoginForm}
              >
                <Icons name="icon_user" />
                <span>{ROUTES.LOGIN.NAME}</span>
              </Button>
            </li>
            <li className="header-mainnav__item header-mainnav__item--mobile">
              <Button
                className={`header-auth__registration ${isActiveRegButton}`}
                variant="link"
                onClick={setWebRegistrationForm}
              >
                <Icons name="icon_key" />
                <span>{ROUTES.REGISTRATION.NAME}</span>
              </Button>
            </li>
          </ul>
        </nav>

        <div className="header-auth">
          <Button
            className={`header-auth__login ${isActiveLoginButton}`}
            onClick={setWebLoginForm}
          >
            <Icons name="icon_user" />
            <span>{ROUTES.LOGIN.NAME}</span>
          </Button>
          <Button
            className={`header-auth__registration ${isActiveRegButton}`}
            variant="link"
            onClick={setWebRegistrationForm}
          >
            <Icons name="icon_key" />
            <span>{ROUTES.REGISTRATION.NAME}</span>
          </Button>
        </div>
      </div>
    </header>
  );
};
